export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Best Graduate of English Education Department University of Wijaya Kusuma Surabaya',
            issuer:'Issued by Faculty of Language and Science, University of Wijaya Kusuma Surabaya · Jul 2020',
            details : 'Associated with Universitas Wijaya Kusuma Surabaya',
            date : 'Jul 2020',
            field : '',
            image : 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
        },
        {
            id : 2,
            title : 'Author of a paper published in Journal of English Language Teaching',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details :'International Malaysian Academic Association Congress Symposium 2019',
            date : '2020',
            field : '',
            image : 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 3,
            title : 'Presenter of a paper in International Malaysian Academic Association Congress Symposium',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details : 'International Innovation and Invention Challenge via Exhibition 2019',
            date : '2019',
            field : '',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 4,
            title : 'Silver Award in International Innovation and Invention Challenge via Exhibition',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details : 'International Innovation and Invention Challenge via Exhibition 2019',
            date : '2019',
            field : '',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 5,
            title : 'Third Winner of Most Outstanding Students University of Wijaya Kusuma Surabaya',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details : 'International Innovation and Invention Challenge via Exhibition 2019',
            date : '2019',
            field : '',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 6,
            title : 'Third Winner of Teacher Idol National Competition.',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details : 'International Innovation and Invention Challenge via Exhibition 2019',
            date : '2018',
            field : '',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 7,
            title : 'Presenter of a paper in International Conference on Innovation in Research ',
            issuer:'Issued by Politeknik Sultan Mizan Zainal Abidin, Trengganu, Malaysia · Sep 2019',
            details : 'International Innovation and Invention Challenge via Exhibition 2019',
            date : '2018',
            field : '',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/